import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const NavBar = () => {
  const isLogin = useSelector((state) => state.loginUser.isLogin);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleItemClick = () => {
    setIsNavCollapsed(true);
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light"
      style={{ padding: "0" }}
    >
      <div className="container-fluid">
        <button
          style={{ border: "none" }}
          className="navbar-toggler p-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          <span
            className="navbar-toggler-icon"
            style={{ width: "20px" }}
          ></span>
        </button>
        <div
          className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto">
            <li className="nav-item me-3">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Trang chủ
              </NavLink>
            </li>
            <li className="nav-item me-3">
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Sản phẩm
              </NavLink>
            </li>

            <li className="nav-item me-3">
              <NavLink
                to="/promotion"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Khuyến mại
              </NavLink>
            </li>

            <li className="nav-item me-3">
              <NavLink
                to="/news"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                News
              </NavLink>
            </li>
            <li className="nav-item me-3">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Giới thiệu
              </NavLink>
            </li>
            <li className="nav-item me-3">
              <NavLink
                to="/shop"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Shop
              </NavLink>
            </li>
            {isLogin && (
              <li className="nav-item me-3">
                <NavLink
                  to="/orders"
                  className={({ isActive }) =>
                    isActive ? "nav-link  text-danger" : "nav-link text-primary"
                  }
                  onClick={() => handleItemClick()}
                >
                  Your orders
                </NavLink>
              </li>
            )}

            <li className="nav-item me-3">
              <NavLink
                to="/lucky"
                className={({ isActive }) =>
                  isActive ? "nav-link  text-danger" : "nav-link text-primary"
                }
                onClick={() => handleItemClick()}
              >
                Game
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
